import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20living%20room%20scene%20with%20sofa%20and%20warm%20lighting%2C%20nostalgic%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%2C%20cozy%20home%20atmosphere%2C%20books%20on%20shelf%2C%20family%20photos%20on%20wall%2C%20emotional%20warmth%2C%20cinematic%20composition%2C%20soft%20textures%2C%20amber%20and%20cream%20tones%2C%20peaceful%20domestic%20scene&width=1800&height=900&seq=hero-bg-2024&orientation=landscape"
        alt="伦理剧精选 - 感动人心的家庭情感故事"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/35 to-foreground-950/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight max-w-3xl">
          每一部伦理剧，都是一面照见人生的镜子
        </h1>
        <p className="text-sm md:text-lg text-background-100/90 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          伦理剧精选汇聚最新最热伦理剧推荐、深度剧情解析与专业观看指南，
          帮助你在纷繁复杂的剧海中找到最触动心灵的那一部作品。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/jingdian-lunli"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索经典伦理剧
          </Link>
          <Link
            to="/category/guochan-lunli"
            className="px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-sm md:text-base font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap"
          >
            国产伦理剧大全
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-8 md:mt-12">
          <div className="text-center">
            <p className="text-xl md:text-2xl font-heading font-bold text-accent-300">2000+</p>
            <p className="text-xs text-background-100/70 mt-1">剧集收录</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-heading font-bold text-accent-300">500万+</p>
            <p className="text-xs text-background-100/70 mt-1">忠实读者</p>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-xl md:text-2xl font-heading font-bold text-accent-300">98%</p>
            <p className="text-xs text-background-100/70 mt-1">好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}